import { Flex } from 'antd';
import styled from 'styled-components';

export const SWrapper = styled(Flex)`
  padding: 24px 0 8px;
`;

export const SLogoText = styled.span`
  font-size: 22px;
  font-weight: 500;
`;

export const SSubtitle = styled.span`
  font-size: 14px;
  color: rgba(102, 112, 133, 0.9);
`;
